import { render, staticRenderFns } from "./CampPlacement.vue?vue&type=template&id=22f45726&lang=pug&"
import script from "./CampPlacement.vue?vue&type=script&lang=js&"
export * from "./CampPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports